import { consultationRebookingFlow } from '@/modules/wizard/flows/consultation-rebooking.flow'
import { emailVerificationFlow } from '@/modules/wizard/flows/email-verification.flow'
import { matchingQuizFlow } from '@/modules/wizard/flows/matching-quiz.flow'
import { onboardingFlow } from '@/modules/wizard/flows/onboarding.flow'
import { passwordSetupFlow } from '@/modules/wizard/flows/password-setup.flow'
import type { WizardFlowDefinition } from '@/modules/wizard/types/WizardFlowDefinition'

/**
 * Every flow the overlay can render, keyed by the name the backend sends as
 * `initiateFlow` (see the backend enum `Modules\WizardFlow\Enums\WizardFlowName`)
 * or the frontend passes to `wizardFlowsStore.setInitiateFlow`.
 */
export const wizardFlows = {
  OnboardingFlow: onboardingFlow,
  EmailVerificationFlow: emailVerificationFlow,
  PasswordSetupFlow: passwordSetupFlow,
  ConsultationRebookingFlow: consultationRebookingFlow,
  MatchingQuizFlow: matchingQuizFlow,
} satisfies Record<string, WizardFlowDefinition>
